const settingsInitialState = {
  languages: [],
  language: false,
  useNewDesign: true
}

export default settingsInitialState;
